import { useCallback, useEffect, useState } from "react";
import { useFunnelsApi } from "../api/funnelsApi";

export function useFunnelPipeline({ funnelId, stalledDays } = {}) {
  const api = useFunnelsApi();
  const [pipeline, setPipeline] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPipeline = useCallback(async () => {
    try {
      setLoading(true);
      const data = await api.getPipeline({ funnelId, stalledDays });
      setPipeline(data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [api, funnelId, stalledDays]);

  useEffect(() => {
    fetchPipeline();
  }, [fetchPipeline]);

  return { pipeline, loading, error, refetch: fetchPipeline };
}
